import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingContainer = (props: Props) => {
  const { children } = props;

  const { right: safeAreaRightInset, left: safeAreaLeftInset } = useSafeAreaInsets();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerDynamicStyles = useStyle(() => {
    return {
      paddingRight: getHorizontalPadding(safeAreaRightInset),
      paddingLeft: getHorizontalPadding(safeAreaLeftInset),
    };
  }, [safeAreaRightInset, safeAreaLeftInset]);

  const containerStyles = [styles.container, containerDynamicStyles];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View role="navigation" pointerEvents="box-none" style={containerStyles}>
      {children}
    </View>
  );
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getHorizontalPadding(safeAreaInset: number) {
  if (safeAreaInset > 0) {
    return safeAreaInset + theme.spacing['3'];
  }

  return theme.spacing['4'];
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFill,
    zIndex: theme.zIndex.fixed,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing['4'],
    maxWidth: 1520,
    marginHorizontal: 'auto',
    paddingTop: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
